import request from '@/utils/request';


let server = {
  shoppingMall: '/gifts', // 商城大礼包
  shoppingCoupons: '/coupons', // 商城优惠券
  shoppingFull: '/reductions', // 商城满减
  receiveCoupons: '/coupons', // 领取优惠卷
  myCoupons: '/my_coupons', // 我的优惠券
  isMyCoupons: '/order_coupons', // 我的优惠券
};


//  商城大礼包
export function shoppingMall(goods) {
	return request({
    	url: server.shoppingMall + '/' + goods ,
	    method: 'get',
  	})
}

//  商城优惠券
export function shoppingCoupons(goods) {
	return request({
    	url: server.shoppingCoupons + '/' + goods,
	    method: 'get',
  	})
}


//  满减
export function shoppingFull(goods) {
  return request({
    url: server.shoppingFull + '?' + goods ,
    method: 'get',
  })
}


//  领取优惠券
export function receiveCoupons(coupon) {
  return request({
    url: server.receiveCoupons + '/' + coupon ,
    method: 'post',
  })
}

//  我的优惠券
export function myCoupons(type) {
  return request({
    url: server.myCoupons + '/' + type,
    method: 'get',
  })
}


//  商城可使用的我的优惠券
export function isMyCoupons(goods) {
  return request({
    url: server.isMyCoupons + '?' + goods,
    method: 'get'
  })
}









// WEBPACK FOOTER //
// ./src/api/activity.js